module.exports = __webpack_public_path__ + "static/media/backdrop-signature.faf41192.png";